export const AGE_MIN: number = 0;
export const AGE_MAX: number = 16;

// permet de fixer le délai des requêtes (latence)
export const REQUEST_DELAY: number = 500
